import { useContext } from "react";
import VspPortalContext from "../../../store/VspPortalContext";
import { HttpMethods } from "../../../enums/HttpMethods";
import { NotificationTypes } from "../../../enums/NotificationTypes";
import { VspPortalActions } from "../../../store/VspPortalActions";
import { GridSortItem } from "@mui/x-data-grid";
import { ArrivalLogDto } from "../dtos/ArrivalLogDto";
import { useVspPortalHttp } from "../../../hooks/useVspPortalHttp";


export const useArrivalLogsHttp = ( ): {

    getArrivalLog( 
        cardNumber: string | undefined
        , employeeNumber: string | undefined
        , firstName: string | undefined
        , fromDate: string | undefined
        , pageNumber: number
        , pageSize: number
        , roomNumber: string | undefined
        , sorting: GridSortItem
        , surname: string | undefined
        , toDate: string | undefined
        , villageCode: string 
    ) : Promise< ArrivalLogDto | null >

} => {

    const { dispatch, state } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );

    const getArrivalLog = async( 
            cardNumber: string | undefined
            , employeeNumber: string | undefined
            , firstName: string | undefined
            , fromDate: string | undefined
            , pageNumber: number
            , pageSize: number
            , roomNumber: string | undefined
            , sorting: GridSortItem
            , surname: string | undefined
            , toDate: string | undefined
            , villageCode: string 
        ) : Promise< ArrivalLogDto | null > => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        let query = `${ process.env.REACT_APP_API_URL }/arrival-logs?`;

        if( cardNumber )
        {

            query += `cardNumber=${ cardNumber }&`;

        }

        if( employeeNumber )
        {

            query += `employeeNumber=${ employeeNumber }&`;

        }

        if( firstName )
        {

            query += `firstName=${ firstName }&`;

        }

        if( fromDate )
        {

            query += `fromDate=${ fromDate }&`;

        }

        if( roomNumber )
        {

            query += `roomNumber=${ roomNumber }&`;

        }

        if( surname )
        {

            query += `surname=${ surname }&`;

        }

        if( toDate )
        {

            query += `toDate=${ toDate }&`;

        }
        
        query +=
            'pageNumber=' + pageNumber
            + '&pageSize=' + pageSize
            + '&orderBys=' + sorting.field
            + '&orderByAsc=' + ( sorting.sort === 'asc' ? 'true' : 'false' )
            + `&villageCode=${ villageCode }`;


        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching arrival logs' });
            return null;

        }

        return await response.response?.json( );


    };

    return {

        getArrivalLog

    };

};